import React, { FunctionComponent, useState } from 'react';

type Props = {
  className: string;
  isNecessary?: boolean;
  label: string;
  annotation?: string;
  width: string;
  name: string;
  array: (string | number | { parent_id: number })[][];
  parentId?: string;
  arrow: string;
  select: string;
  onChanged: (name: string, value: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  className,
  isNecessary,
  label,
  annotation,
  width,
  name,
  array,
  parentId,
  arrow,
  select,
  onChanged,
}) => {
  const [internalValue, setInternalValue] = useState('');
  const isSmallCategory = name === 'occupationDetail' || name === 'preferredOccupationDetail';
  const isNotScout = name !== 'scoutFlag';

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = event.target.value;
    const name = event.target.name;
    setInternalValue(newValue);
    onChanged(name, newValue);
  };

  const filteredArray =
    isSmallCategory && Array.isArray(array)
      ? array.filter((item) => {
          const thirdElement = item[2];
          return (
            typeof thirdElement === 'object' &&
            thirdElement !== null &&
            'parent_id' in thirdElement &&
            thirdElement.parent_id === Number(parentId)
          );
        })
      : array;

  return (
    <label htmlFor={name} className={className}>
      <span className="label--title">{label}</span>
      {isNecessary && <span className="label--necessary">必須</span>}
      <select
        onChange={handleChange}
        className={`label--input ${width} ${arrow} ${select}`}
        name={name}
        value={internalValue}
      >
        {isNotScout && <option key="0" value=""></option>}
        {Array.isArray(filteredArray) &&
          filteredArray.map((item) => (
            <option key={item[0] as string | number} value={item[0] as string | number}>
              {item[1] as string}
            </option>
          ))}
      </select>
      {annotation !== '' && <p className="label--annotation">{annotation}</p>}
    </label>
  );
};
